import React from "react";

import { Row, Col, Container } from "react-bootstrap";

import { PALETTE } from "../../common/ThemeConstants";
import HomeImageCard from "./HomeImageCard";

export default function HomeCards({ categories }) {
  return (
    <Container>
      <Container className="align-self-center text-center ms-auto me-auto">
        <h1 className="text-center">
          3. Scegli <span style={{ fontWeight: "bold" }}>il tuo piano</span> di
          allenamento
        </h1>
        <p style={{ color: PALETTE.DARK }}>
          Scegli il piano di allenamento che più si adatta alle tue esigenze e
          obiettivi
        </p>
      </Container>
      <br />
      <Row>
        {categories.length > 0 &&
          categories.map((category) => (
            <Col md style={{ margin: "5px 2px" }} key={category.id}>
              <HomeImageCard
                to={"/account/Workouts/" + category.name}
                cover={category.cover}
                text={category.name}
              />
            </Col>
          ))}
        {categories.length == 0 && (
          <div className="m-auto text-center" style={{ color: PALETTE.GRAY }}>
            <p>No plan available, check your connection</p>
          </div>
        )}
      </Row>
    </Container>
  );
}
